import { render, staticRenderFns } from "./UserOrderTables.vue?vue&type=template&id=b1ea43b8&"
import script from "./UserOrderTables.vue?vue&type=script&lang=js&"
export * from "./UserOrderTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports